import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class MenuItem extends Base {
  isOpen = false;
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'MenuItem',
    refs: ['subsubmenu', 'back'],
    emits: ['open'],
    options: {
      depth: {
        default: 0,
        type: Number,
      },
    },
  };

  /**
   * Handle click on menu item.
   * @param {object} props Props
   * @param {object} props.event The click event
   */
  onClick({ event }) {
    if (!this.isOpen && window.innerWidth < 1024) {
      event.preventDefault();
      this.$refs.subsubmenu.classList.remove('max-m:translate-x-full');
      this.isOpen = true;
    }
  }

  /**
   * Click on back btn
   * @param {object} props Props
   * @param {object} props.event current event
   * @returns {void}
   */
  onBackClick({ event }) {
    event.stopPropagation();
    if (this.isOpen) {
      this.$refs.subsubmenu.classList.add('max-m:translate-x-full');
    }
    this.isOpen = false;
  }
}
